export interface MeetingPlace {
  name: string;
  commune: string;
  address: string;
  lat: number;
  lng: number;
  note?: string;
}

export const BRUSSELS_CENTER = { lat: 50.8467, lng: 4.3525 };

export const BRUSSELS_PILOT_PLACES: MeetingPlace[] = [
  {
    name: 'Bibliothèque Muntpunt',
    commune: 'Bruxelles-Centre',
    address: 'Place de la Monnaie 6, 1000 Bruxelles',
    lat: 50.8497,
    lng: 4.3536,
    note: 'Grande médiathèque, hall d’accueil visible.',
  },
  {
    name: 'Bibliothèque des Riches-Claires',
    commune: 'Bruxelles-Centre',
    address: 'Rue des Riches-Claires 24, 1000 Bruxelles',
    lat: 50.8461,
    lng: 4.3469,
  },
  {
    name: 'BiblioJette',
    commune: 'Jette',
    address: 'Chaussée de Wemmel 126, 1090 Jette',
    lat: 50.8772,
    lng: 4.3248,
  },
  {
    name: 'Bibliothèque Hergé',
    commune: 'Etterbeek',
    address: 'Boulevard Louis Schmidt 4, 1040 Etterbeek',
    lat: 50.8319,
    lng: 4.3942,
  },
  {
    name: 'Bibliothèque communale d’Ixelles',
    commune: 'Ixelles',
    address: 'Rue Jean Van Volsem 43, 1050 Ixelles',
    lat: 50.8328,
    lng: 4.3731,
  },
  {
    name: 'Bibliothèque de Saint-Gilles',
    commune: 'Saint-Gilles',
    address: 'Rue de Rome 18, 1060 Saint-Gilles',
    lat: 50.8294,
    lng: 4.3456,
  },
  {
    name: 'Bibliothèque de Schaerbeek — Louis Bertrand',
    commune: 'Schaerbeek',
    address: 'Place Louis Bertrand 37, 1030 Schaerbeek',
    lat: 50.8633,
    lng: 4.3764,
  },
  {
    name: 'Bibliothèque de Forest',
    commune: 'Forest',
    address: 'Place Saint-Denis 7, 1190 Forest',
    lat: 50.8136,
    lng: 4.3189,
  },
];
